import { metadata } from './metadata'
import { dimensions, mapData } from './mapping'
import { visualOptions } from './visualOptions'
import render from './render' // render is default export in render.js

export default {
    metadata,
    dimensions,
    mapData,
    visualOptions,
    render,
}
